import React from 'react';
import ScoreForm from '../../../components/Models/Scores/ScoreForm';

function ScorePage() {
  return <ScoreForm />;
}

export default ScorePage;
